import { createSelector } from 'reselect';

const getCards = (state) => state['sportsbook/overview'].cards;

export default createSelector(
  getCards,
  (cards) => cards.filter((card) => !card.hidden),
);
